
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CreateRequest } from '@/modules/calendar';
import { ElForm } from 'element-ui/types/form';

interface RequestRules {
  date: object[];
  isUseBaseSchedule: object[];
}

@Component({
  components: {}
})
export default class extends Vue {
  private get title() { return '新しい月の予約カレンダーを追加'; }
  private readonly REQUEST_RULE: RequestRules = {
    date: [{ required: true, message: '年月は必須項目です。', trigger: 'blur' }],
    isUseBaseSchedule: [],
  };

  private get request(): CreateRequest { return this.$store.state.calendar.createRequest; }

  @Prop({required: true})
  private isActive!: boolean;
  private isVisible = this.isActive;
  private isLoading = false;

  @Watch('isActive')
  private onChangedIsActive() {
    this.isVisible = this.isActive;
  }

  @Watch('isVisible')
  private onChangedIsVisible() {
    this.$emit('update:isActive', this.isVisible);
  }

  private send() {

    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this as any).$confirm('入力情報で追加します。よろしいですか？', '追加確認', {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        })
        .then(async () => {
          this.isLoading = true;

          this.$emit('send');

          this.isVisible = false;
          this.isLoading = false;
        })
        .catch();
      }
    });
  }

  private cancel() {
    this.isVisible = false;
  }

  @Watch('request.date')
  private async onChangedRequestDate() {
    if (!this.request.date) { return; }

    this.isLoading = true;

    // 作成に使用できる日塚かどうか api に問い合わせる
    await this.$emit('request-date-validate');

    this.isLoading = false;
  }
}
